const buttons = document.querySelectorAll('.tabs__button');
const contents = document.querySelectorAll('.tabs__content');

buttons.forEach(button => {
  button.addEventListener('click', () => {
    const tabId = button.getAttribute('data-tab');

    buttons.forEach(btn => btn.classList.remove('active'));
    contents.forEach(content => content.classList.remove('active'));

    button.classList.add('active');
    document.getElementById(`tab-${tabId}`).classList.add('active');
  });
});
